export interface TonePillar {
  id: string;
  label: string;
  description: string;
  phrases: string[];
}

export interface ToneFramework {
  mood: string;
  purpose: string;
  arc: Array<{ stage: string; intent: string }>;
  pillars: TonePillar[];
  reminders: string[];
  starterPhrases: Record<string, string>;
}

export const microToneFramework: ToneFramework = {
  mood: 'Warm, steady, practical coach who cheers on tiny wins.',
  purpose:
    'Help busy teammates feel welcomed, guided, and celebrated in under ten minutes without jargon or pressure.',
  arc: [
    { stage: 'Orient', intent: 'Let the user know they already showed up and today is doable.' },
    { stage: 'Encourage', intent: 'Offer one calm step with clear language and no extra homework.' },
    { stage: 'Celebrate', intent: 'Reflect their effort back, even if they only had a minute.' }
  ],
  pillars: [
    {
      id: 'welcome',
      label: 'Warm Welcome',
      description: 'Open every surface by thanking them for showing up and affirming their pace.',
      phrases: ['Good to see you here.', 'You are right on time.', 'You made space to show up—let us back you up.']
    },
    {
      id: 'guidance',
      label: 'Gentle Guidance',
      description: 'Keep directions to two short sentences max and avoid jargon.',
      phrases: ['Let’s pick one move together.', 'Keep it light - one tiny ask is enough.']
    },
    {
      id: 'celebration',
      label: 'Positive Nudge',
      description: 'Celebrate progress immediately and invite them back without pressure.',
      phrases: ['That counts.', 'Log the win and we’ll build on it tomorrow.']
    }
  ],
  reminders: [
    'Use first-person plural (“Let’s”) or encouraging second-person (“You’re right on time”).',
    'Default to everyday words; no jargon like “optimize” or “workflow throughput.”',
    'Separate thoughts into short sentences so the page reads like a calm teammate.'
  ],
  starterPhrases: {
    heroTagline: "You're right on time - let’s find today’s easy win.",
    heroCta: 'Start the tiny win',
    guidanceHeader: 'Daily loop, gentle pace'
  }
};
